import React, { useState } from "react";
import "../styles/OurCoreValues.css";
import HomePageContent from "./HomePageContent";
import honest from "../../../Images/honesty.png";
import innovate from "../../../Images/innovate.png";
import strength from "../../../Images/Strength.png";
import customer from "../../../Images/Customer.png";
import execute from "../../../Images/Execute.png";
import lead from "../../../Images/Lead.png";
import passion from "../../../Images/Passion.png";

const coreValuesData = [
    { img: honest, title: HomePageContent.honesty_and_integrity_Title, content: HomePageContent.honesty_and_integrity_Content },
    { img: innovate, title: HomePageContent.innovate_relentlessly_Title, content: HomePageContent.innovate_relentlessly_Content },
    { img: strength, title: HomePageContent.strength_in_resiliency_Title, content: HomePageContent.strength_in_resiliency_Content },
    { img: customer, title: HomePageContent.Customer_Centric_focus_Title, content: HomePageContent.Customer_Centric_focus_Content },
    { img: execute, title: HomePageContent.Execute_with_intention_Title, content: HomePageContent.Execute_with_intention_Content },
    { img: lead, title: HomePageContent.Lead_with_Humility_Title, content: HomePageContent.Lead_with_Humility_Content },
    { img: passion, title: HomePageContent.Passion_and_Commitment_Title, content: HomePageContent.Passion_and_Commitment_Content },
];

const OurCoreValues = () => {
    const [startIndex, setStartIndex] = useState(0);
    const visibleItems = 3;

    const handleNext = () => {
        if (startIndex + visibleItems < coreValuesData.length) {
            setStartIndex(startIndex + visibleItems);
        }
    };

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - visibleItems);
        }
    };

    const isNextDisabled = startIndex + visibleItems >= coreValuesData.length;
    const isPrevDisabled = startIndex === 0;


    return (
        <div className="our-core-values" id="our-core-values">
            <div className="our-core-values-content">
                <div className="our-core-values-title">{HomePageContent.our_Core_Values_Title}</div>
                <div className="our-core-principle-container">
                    {coreValuesData.slice(startIndex, startIndex + visibleItems).map((value, index) => (
                        <div className="our-core-principle" key={index}>
                            <div className="honesty-and-integrity-image">
                                <img className="honest-and-integrity-image-container" src={value.img} alt={value.title} />
                            </div>
                            <div className="honesty-and-integrity">{value.title}</div>
                            <div className="honesty-and-integrity-content">{value.content}</div>
                        </div>
                    ))}
                </div>
                <div className="button-right-left">
                    <button
                        className={`arrow-button left-arrow ${isPrevDisabled ? "disabled-button" : ""}`}
                        onClick={handlePrev}
                        disabled={isPrevDisabled}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="16" viewBox="0 0 30 16" fill="none">
                            <path d="M28.5 9C29.0523 9 29.5 8.55228 29.5 8C29.5 7.44772 29.0523 7 28.5 7L28.5 9ZM0.792891 7.29289C0.402367 7.68342 0.402367 8.31658 0.79289 8.7071L7.15685 15.0711C7.54738 15.4616 8.18054 15.4616 8.57107 15.0711C8.96159 14.6805 8.96159 14.0474 8.57107 13.6569L2.91421 8L8.57107 2.34314C8.96159 1.95262 8.96159 1.31945 8.57107 0.92893C8.18054 0.538406 7.54738 0.538406 7.15685 0.92893L0.792891 7.29289ZM28.5 7L1.5 7L1.5 9L28.5 9L28.5 7Z" fill="black" />
                        </svg>                    </button>
                    <button
                        className={`arrow-button right-arrow ${isNextDisabled ? "disabled-button" : ""}`}
                        onClick={handleNext}
                        disabled={isNextDisabled}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="16" viewBox="0 0 30 16" fill="none">
                            <path d="M1.5 7C0.947715 7 0.5 7.44772 0.5 8C0.5 8.55228 0.947715 9 1.5 9V7ZM29.2071 8.70711C29.5976 8.31658 29.5976 7.68342 29.2071 7.29289L22.8431 0.928932C22.4526 0.538408 21.8195 0.538408 21.4289 0.928932C21.0384 1.31946 21.0384 1.95262 21.4289 2.34315L27.0858 8L21.4289 13.6569C21.0384 14.0474 21.0384 14.6805 21.4289 15.0711C21.8195 15.4616 22.4526 15.4616 22.8431 15.0711L29.2071 8.70711ZM1.5 9H28.5V7H1.5V9Z" fill="black" />
                        </svg>
                    </button>
                </div>


            </div>
        </div>
    );
};

export default OurCoreValues;
